(function () {
  'use strict';

  if (window.__eaAssistantLoaded) return;
  window.__eaAssistantLoaded = true;

  const container = document.getElementById('espace-abonne') || document.getElementById('assistant-views');
  if (!container) return;
  const launcherMode = container.dataset.launcher === '1';

  const email = container.dataset.email || '';
  const ts = container.dataset.ts || '';
  const sig = container.dataset.sig || '';
  const apiBase = (container.dataset.apiUrl || 'https://hub.views.fr/api/customer') + '/assistant';
  const isAnon = !email || !ts || !sig;

  const keySuffix = isAnon ? 'anon' : email;
  const TOKEN_KEY = 'ea_assist_token_' + keySuffix;
  const CONV_KEY = 'ea_assist_conv_' + keySuffix;
  let sessionToken = null;
  let conversationId = null;
  try {
    sessionToken = sessionStorage.getItem(TOKEN_KEY);
    conversationId = sessionStorage.getItem(CONV_KEY);
  } catch (e) {}
  let sending = false;

  function ensureConversationId() {
    if (!conversationId) {
      conversationId = cryptoRandomId();
      try { sessionStorage.setItem(CONV_KEY, conversationId); } catch (e) {}
    }
    return conversationId;
  }

  function resetConversation() {
    conversationId = null;
    try { sessionStorage.removeItem(CONV_KEY); } catch (e) {}
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function el(html) {
    const t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  const SLA = '72 h ouvrées';
  const FALLBACK_HTML =
    '<div class="ea-assist-fallback">L’assistant est momentanément indisponible. Écris-nous à <a href="mailto:abonnement@views.fr">abonnement@views.fr</a>, réponse sous ' + SLA + '.</div>';

  let panel = null;
  let messagesBox = null;
  let input = null;
  let sendBtn = null;
  let lastFocus = null;

  function buildPanel() {
    panel = el(
      '<div class="ea-assist-panel" role="dialog" aria-modal="true" aria-label="Assistant abonnés Views" hidden>' +
        '<div class="ea-assist-head">' +
          '<div class="ea-assist-head-txt">' +
            '<div class="ea-assist-title">Assistant Views</div>' +
            '<div class="ea-assist-sub">Réponse immédiate, 24/7</div>' +
          '</div>' +
          (isAnon
            ? '<a class="ea-assist-tickets-btn" href="/account"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg><span>Me connecter</span></a>'
            : '<button type="button" class="ea-assist-tickets-btn" aria-expanded="false"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg><span>Mes demandes</span></button>') +
          '<button class="ea-assist-close" aria-label="Fermer l’assistant">&times;</button>' +
        '</div>' +
        '<div class="ea-assist-messages" aria-live="polite"></div>' +
        '<form class="ea-assist-form">' +
          '<textarea class="ea-assist-input" rows="1" maxlength="2000" placeholder="Ta question…" aria-label="Ta question"></textarea>' +
          '<button type="submit" class="ea-assist-send" aria-label="Envoyer">Envoyer</button>' +
        '</form>' +
        '<div class="ea-assist-foot">' + (isAnon ? 'Je te renseigne sur le magazine, les abonnements et les achats sur views.fr. Pour tes commandes et ton abonnement, connecte-toi sur views.fr/account.' : 'L’assistant connaît ton abonnement et peut transmettre ton dossier à un humain (réponse sous ' + SLA + '). Conversations conservées 90 jours pour le suivi, effacement sur demande à abonnement@views.fr.') + '</div>' +
      '</div>'
    );
    document.body.appendChild(panel);
    messagesBox = panel.querySelector('.ea-assist-messages');
    input = panel.querySelector('.ea-assist-input');
    sendBtn = panel.querySelector('.ea-assist-send');

    panel.querySelector('.ea-assist-close').addEventListener('click', closePanel);
    if (!isAnon) panel.querySelector('.ea-assist-tickets-btn').addEventListener('click', showMyTickets);
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });
    panel.querySelector('.ea-assist-form').addEventListener('submit', function (e) {
      e.preventDefault();
      submitMessage();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        submitMessage();
      }
    });
    input.addEventListener('input', function () {
      input.style.height = 'auto';
      input.style.height = Math.min(input.scrollHeight, 120) + 'px';
    });
  }

  const OPEN_KEY = 'ea_assist_openstate_' + email;

  let restoreStarted = false;
  let restorePromise = null;
  async function restoreHistory() {
    if (restoreStarted) return true;
    restoreStarted = true;
    if (isAnon) return false; // conversation anonyme = éphémère (pas de restauration cross-page)
    let convId = null;
    try { convId = sessionStorage.getItem(CONV_KEY); } catch (e) {}
    if (!convId) return false;
    if (!(await ensureSession())) { resetConversation(); return false; }
    try {
      const r = await api('/conversation-history', { sessionToken: sessionToken, email: email, conversationId: convId });
      if (r.status === 200 && Array.isArray(r.data.messages) && r.data.messages.length > 0) {
        r.data.messages.forEach(function (m) {
          if (m.role === 'user') addUser(m.content); else addAssistant(m.content);
        });
        addInfo('<div class="ea-assist-resumed">Ta conversation a été reprise là où tu l’avais laissée.</div>');
        return true;
      }
    } catch (e) {}
    resetConversation();
    return false;
  }

  function openPanel() {
    if (!panel) buildPanel();
    lastFocus = document.activeElement;
    panel.hidden = false;
    document.body.classList.add('ea-assist-open');
    try { sessionStorage.setItem(OPEN_KEY, '1'); } catch (e) {}
    if (!messagesBox.childElementCount && !restorePromise) {
      restorePromise = restoreHistory().then(function (restored) {
        if (!restored && messagesBox && !messagesBox.childElementCount) {
          addAssistant(isAnon
            ? 'Salut ! Je suis l’assistant Views. Je te renseigne sur le magazine, les abonnements, les numéros et les achats sur views.fr. Pour ta commande ou ton abonnement perso, il faudra te connecter. Qu’est-ce que tu veux savoir ?'
            : 'Salut ! Je suis l’assistant Views. Une question sur ton abonnement, un numéro qui n’arrive pas, un reçu, ton adresse ? Je regarde tes données en direct et je réponds tout de suite.');
          showPresets();
        }
      });
    }
    input.focus();
  }

  var PRESET_ICONS = {
    numero: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>',
    colis: '<path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/>',
    abo: '<path d="m17 2 4 4-4 4"/><path d="M3 11v-1a4 4 0 0 1 4-4h14"/><path d="m7 22-4-4 4-4"/><path d="M21 13v1a4 4 0 0 1-4 4H3"/>',
    adresse: '<path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>',
    recu: '<path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/><path d="M12 17.5v-11"/>',
  };
  function presetIcon(key) {
    return '<svg class="ea-preset-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (PRESET_ICONS[key] || '') + '</svg>';
  }

  const PRESETS = [
    { icon: 'numero', label: 'Où en est mon prochain numéro ?' },
    { icon: 'colis', label: 'Où est ma commande views.fr ?' },
    { icon: 'abo', label: 'Mon abonnement en un coup d’œil' },
    { icon: 'adresse', label: 'Je veux changer mon adresse' },
    { icon: 'recu', label: 'Mes reçus et factures' },
  ];

  const ANON_PRESETS = [
    { icon: 'numero', label: 'C’est quoi Views ?' },
    { icon: 'abo', label: 'Combien coûte l’abonnement ?' },
    { icon: 'numero', label: 'Quand paraît le prochain numéro ?' },
    { icon: 'colis', label: 'Comment acheter un numéro ?' },
    { icon: 'recu', label: 'Comment me connecter ?' },
  ];

  function showPresets() {
    if (panel.querySelector('.ea-assist-presets')) return;
    const box = el('<div class="ea-assist-presets" role="group" aria-label="Suggestions"></div>');
    (isAnon ? ANON_PRESETS : PRESETS).forEach(function (preset) {
      const chip = el('<button type="button" class="ea-assist-preset">' + presetIcon(preset.icon) + '<span>' + esc(preset.label) + '</span></button>');
      chip.addEventListener('click', function () {
        removePresets();
        input.value = preset.label;
        submitMessage();
      });
      box.appendChild(chip);
    });
    messagesBox.appendChild(box);
    messagesBox.scrollTop = messagesBox.scrollHeight;
  }

  function removePresets() {
    const box = panel && panel.querySelector('.ea-assist-presets');
    if (box) box.remove();
  }

  function closePanel() {
    if (!panel) return;
    panel.hidden = true;
    document.body.classList.remove('ea-assist-open');
    try { sessionStorage.setItem(OPEN_KEY, '0'); } catch (e) {}
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function addBubble(cls, html) {
    const b = el('<div class="ea-assist-msg ' + cls + '">' + html + '</div>');
    messagesBox.appendChild(b);
    messagesBox.scrollTop = messagesBox.scrollHeight;
    return b;
  }

  function linkify(html) {
    return html.replace(/(?:https?:\/\/|www\.)[^\s<>«»()]+[^\s<>«»().,!?:;]/g, function (url) {
      var href = url.indexOf('http') === 0 ? url : 'https://' + url;
      if (/\/api\/customer\/invoice\//.test(url)) {
        return '<a class="ea-doc-btn" href="' + href + '" target="_blank" rel="noopener noreferrer"><span class="ea-doc-ic" aria-hidden="true">↓</span>Télécharger la facture (PDF)</a>';
      }
      if (/\/orders\/[^\s]*authenticate/.test(url)) {
        return '<a class="ea-doc-link" href="' + href + '" target="_blank" rel="noopener noreferrer">Voir le reçu ↗</a>';
      }
      return '<a href="' + href + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
    });
  }

  function renderLite(text) {
    return linkify(esc(text.replace(/\n{3,}/g, '\n\n')))
      .replace(/Facture(?:\s+PDF)?\s*:?\s*(<a class="ea-doc-btn")/gi, '$1')
      .replace(/Re[çc]u(?:\s+de\s+commande)?\s*:?\s*(<a class="ea-doc-link")/gi, '$1')
      .replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>')
      .replace(/(^|[\s(])\*([^*\n]+)\*(?=[\s).,!?:;]|$)/g, '$1<em>$2</em>')
      .replace(/^[-•] (.+)$/gm, '<span class="ea-assist-li">$1</span>')
      .replace(/\n/g, '<br>')
      .replace(/<\/span>(<br>)+/g, '</span>')
      .replace(/(<a class="ea-doc-(?:btn|link)"[^>]*>[^<]*<\/a>)(<br>)+/g, '$1<br>');
  }

  function addUser(text) { addBubble('ea-assist-msg--user', esc(text).replace(/\n/g, '<br>')); }
  function addAssistant(text) { addBubble('ea-assist-msg--bot', renderLite(text)); }
  function addInfo(html) { addBubble('ea-assist-msg--info', html); }

  function setBusy(b) {
    sending = b;
    sendBtn.disabled = b;
    input.disabled = b;
    let dots = panel.querySelector('.ea-assist-typing');
    if (b && !dots) {
      dots = el('<div class="ea-assist-typing"><span class="ea-assist-typing-dots"><span></span><span></span><span></span></span><span class="ea-assist-typing-label"></span></div>');
      messagesBox.appendChild(dots);
      messagesBox.scrollTop = messagesBox.scrollHeight;
    } else if (!b && dots) {
      stopProgressPoll();
      dots.remove();
      if (panel && !panel.hidden) input.focus({ preventScroll: true });
    }
  }

  let progressTimer = null;
  let progressInFlight = false;
  let progressStartedAt = 0;
  function startProgressPoll(convId) {
    if (isAnon) return; // /message-progress est réservé aux sessions authentifiées
    stopProgressPoll();
    progressStartedAt = Date.now();
    progressTimer = setInterval(async function () {
      if (Date.now() - progressStartedAt > 45000) { stopProgressPoll(); return; }
      if (!sending || !sessionToken || progressInFlight) return;
      progressInFlight = true;
      try {
        const r = await api('/message-progress', { sessionToken: sessionToken, email: email, conversationId: convId });
        const label = panel && panel.querySelector('.ea-assist-typing-label');
        if (label && r.status === 200 && r.data.progress) {
          label.textContent = r.data.progress;
          label.classList.add('ea-assist-typing-label--on');
        }
      } catch (e) {} finally {
        progressInFlight = false;
      }
    }, 1500);
  }
  function stopProgressPoll() {
    if (progressTimer) { clearInterval(progressTimer); progressTimer = null; }
  }

  function timeoutSignal(ms) {
    try {
      if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') {
        return AbortSignal.timeout(ms);
      }
      if (typeof AbortController === 'function') {
        var c = new AbortController();
        setTimeout(function () { c.abort(new DOMException('TimeoutError', 'TimeoutError')); }, ms);
        return c.signal;
      }
    } catch (e) {}
    return undefined;
  }

  async function api(path, body) {
    const res = await fetch(apiBase + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: timeoutSignal(60000),
    });
    let data = null;
    try { data = await res.json(); } catch (e) {}
    return { status: res.status, data: data || {} };
  }

  async function ensureSession() {
    if (sessionToken) return true;
    const r = await api('/session', isAnon ? { anonymous: true } : { email: email, ts: ts, sig: sig });
    if (r.status === 200 && r.data.sessionToken) {
      sessionToken = r.data.sessionToken;
      try { sessionStorage.setItem(TOKEN_KEY, sessionToken); } catch (e) {}
      return true;
    }
    if (r.status === 503) { addInfo(FALLBACK_HTML); return false; }
    addInfo('<div class="ea-assist-fallback">Ta session a expiré, recharge la page pour relancer l’assistant.</div>');
    return false;
  }

  async function submitMessage() {
    const text = input.value.trim();
    if (!text || sending) return;
    removePresets();
    setBusy(true);
    try {
      if (restorePromise) { try { await restorePromise; } catch (e) {} }
      removePresets();
      addUser(text);
      const dots = panel.querySelector('.ea-assist-typing');
      if (dots) { messagesBox.appendChild(dots); messagesBox.scrollTop = messagesBox.scrollHeight; }
      input.value = '';
      input.style.height = 'auto';
      if (!(await ensureSession())) return;
      const convId = ensureConversationId();
      startProgressPoll(convId);
      const msgId = cryptoRandomId();
      let r = await api('/message', {
        sessionToken: sessionToken, email: email, message: text,
        conversationId: convId, clientMessageId: msgId,
      });
      if (r.status === 401 || r.status === 403) {
        sessionToken = null;
        try { sessionStorage.removeItem(TOKEN_KEY); } catch (e) {}
        if (await ensureSession()) {
          r = await api('/message', {
            sessionToken: sessionToken, email: email, message: text,
            conversationId: convId, clientMessageId: msgId,
          });
        } else {
          return;
        }
      }
      if (r.status === 200) {
        addAssistant(r.data.reply || '');
        if (Array.isArray(r.data.pendingActions)) {
          r.data.pendingActions.forEach(renderPendingAction);
        }
        if (r.data.closed) resetConversation();
        offerFeedback();
      } else if (r.status === 429) {
        addInfo('<div class="ea-assist-fallback">' + esc(r.data.error || 'Trop de messages, réessaie dans quelques minutes.') + '</div>');
      } else if (r.status === 503) {
        addInfo(FALLBACK_HTML);
      } else {
        addInfo('<div class="ea-assist-fallback">' + esc(r.data.error || 'Un souci technique est survenu. Réessaie, ou écris à abonnement@views.fr.') + '</div>');
      }
    } catch (e) {
      if (e && (e.name === 'TimeoutError' || e.name === 'AbortError')) {
        addInfo('<div class="ea-assist-fallback">Le serveur met trop de temps à répondre. Ton message est peut-être bien parti : ouvre « Mes demandes » avant de le renvoyer, pour ne pas créer deux dossiers.</div>');
      } else {
        addInfo(FALLBACK_HTML);
      }
    } finally {
      setBusy(false);
      input.focus({ preventScroll: true });
    }
  }

  function cryptoRandomId() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'm-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  const portalBase = container.dataset.apiUrl || 'https://hub.views.fr/api/customer';

  async function portalCall(method, path, body) {
    const res = await fetch(portalBase + path, {
      method: method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({ email: email, ts: ts, sig: sig }, body)),
      signal: timeoutSignal(60000),
    });
    let data = null;
    try { data = await res.json(); } catch (e) {}
    return { ok: res.ok, data: data || {} };
  }

  function markActionDone(actionType) {
    api('/action-done', {
      sessionToken: sessionToken, email: email,
      conversationId: conversationId, actionType: actionType,
    });
  }

  const ACTION_TEXTS = {
    cancel_renewal: {
      title: 'Arrêter le renouvellement automatique',
      detail: 'Ton abonnement ira jusqu’au bout des numéros déjà payés, puis s’arrêtera. Rien n’est fait tant que tu ne confirmes pas.',
      button: 'Confirmer l’arrêt du renouvellement',
      success: 'C’est fait : le renouvellement automatique est arrêté. Tu recevras tous les numéros déjà payés.',
    },
    reactivate: {
      title: 'Réactiver le renouvellement',
      detail: 'Annule l’arrêt programmé : ton abonnement continuera normalement. Rien n’est fait tant que tu ne confirmes pas.',
      button: 'Confirmer la réactivation',
      success: 'C’est fait : ton abonnement continuera normalement.',
    },
  };

  function renderPendingAction(action) {
    if (action.type === 'address_update') { renderAddressForm(action); return; }
    if (action.type === 'damage_report') { renderDamageForm(action); return; }
    if (action.type === 'reshipment') { renderReshipmentForm(action); return; }
    const texts = ACTION_TEXTS[action.type];
    if (!texts) return;
    const card = el(
      '<div class="ea-assist-action">' +
        '<div class="ea-assist-action-title">' + esc(texts.title) + '</div>' +
        (action.label ? '<div class="ea-assist-action-sub">' + esc(action.label) + '</div>' : '') +
        '<p class="ea-assist-action-detail">' + esc(texts.detail) + '</p>' +
        '<div class="ea-assist-action-row">' +
          '<button type="button" class="ea-assist-action-confirm">' + esc(texts.button) + '</button>' +
          '<button type="button" class="ea-assist-action-dismiss">Annuler</button>' +
        '</div>' +
      '</div>'
    );
    const confirmBtn = card.querySelector('.ea-assist-action-confirm');
    card.querySelector('.ea-assist-action-dismiss').addEventListener('click', function () { card.remove(); });
    confirmBtn.addEventListener('click', async function () {
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'En cours…';
      const path = action.type === 'cancel_renewal' ? '/cancel-renewal' : '/reactivate-renewal';
      try {
        const r = await portalCall('POST', path, { subscriptionId: action.subscriptionId });
        if (r.ok) {
          card.remove();
          addInfo('<div class="ea-assist-success">' + esc(texts.success) + '</div>');
          markActionDone(action.type);
        } else {
          confirmBtn.disabled = false;
          confirmBtn.textContent = texts.button;
          addInfo('<div class="ea-assist-fallback">' + esc(r.data.error || 'Impossible pour le moment, réessaie ou écris à abonnement@views.fr.') + '</div>');
        }
      } catch (e) {
        confirmBtn.disabled = false;
        confirmBtn.textContent = texts.button;
        addInfo(FALLBACK_HTML);
      }
    });
    messagesBox.appendChild(card);
    messagesBox.scrollTop = messagesBox.scrollHeight;
  }

  function renderAddressForm(action) {
    const card = el(
      '<div class="ea-assist-action">' +
        '<div class="ea-assist-action-title">Nouvelle adresse de livraison</div>' +
        '<p class="ea-assist-action-detail">Saisis ta nouvelle adresse ici (elle ne passe pas par la conversation). Ce formulaire n’accepte que les adresses en France : pour un autre pays, demande-le dans la conversation, l’équipe s’en charge.</p>' +
        '<form class="ea-assist-addr">' +
          '<div class="ea-assist-addr-row"><input name="firstName" placeholder="Prénom" autocomplete="given-name"><input name="lastName" placeholder="Nom" required autocomplete="family-name"></div>' +
          '<input name="address1" placeholder="Adresse" required autocomplete="address-line1">' +
          '<input name="address2" placeholder="Complément (facultatif)" autocomplete="address-line2">' +
          '<div class="ea-assist-addr-row"><input name="zip" placeholder="Code postal" required autocomplete="postal-code" pattern="[0-9]{5}"><input name="city" placeholder="Ville" required autocomplete="address-level2"></div>' +
          '<div class="ea-assist-action-row">' +
            '<button type="submit" class="ea-assist-action-confirm">Mettre à jour mon adresse</button>' +
            '<button type="button" class="ea-assist-action-dismiss">Annuler</button>' +
          '</div>' +
        '</form>' +
        '<div class="ea-assist-action-sub">Tu habites hors de France ? Dis-le moi dans la conversation, l’équipe s’en charge.</div>' +
      '</div>'
    );
    const form = card.querySelector('form');
    const submitBtn = card.querySelector('.ea-assist-action-confirm');
    card.querySelector('.ea-assist-action-dismiss').addEventListener('click', function () { card.remove(); });
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      submitBtn.disabled = true;
      submitBtn.textContent = 'En cours…';
      const fd = new FormData(form);
      try {
        const r = await portalCall('PUT', '/address', {
          subscriptionId: action.subscriptionId,
          address: {
            firstName: String(fd.get('firstName') || ''),
            lastName: String(fd.get('lastName') || ''),
            address1: String(fd.get('address1') || ''),
            address2: String(fd.get('address2') || ''),
            city: String(fd.get('city') || ''),
            zip: String(fd.get('zip') || ''),
            country: 'France',
          },
        });
        if (r.ok) {
          const pending = r.data && r.data.pendingVerification === true;
          const msg = (r.data && r.data.message) || (pending
            ? 'Adresse enregistrée. Notre équipe la vérifie avant ta prochaine livraison.'
            : 'Adresse mise à jour. Elle sera utilisée pour les prochains envois.');
          card.remove();
          addInfo('<div class="' + (pending ? 'ea-assist-pending' : 'ea-assist-success') + '">' + esc(msg) + '</div>');
          if (!pending) markActionDone('address_update');
        } else {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Mettre à jour mon adresse';
          addInfo('<div class="ea-assist-fallback">' + esc(r.data.error || 'Impossible pour le moment, réessaie ou écris à abonnement@views.fr.') + '</div>');
        }
      } catch (err2) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Mettre à jour mon adresse';
        addInfo(FALLBACK_HTML);
      }
    });
    messagesBox.appendChild(card);
    messagesBox.scrollTop = messagesBox.scrollHeight;
    card.querySelector('input[name="lastName"]').focus();
  }

  async function uploadDamagePhoto(ticketId, issueNumber, orderRef, file) {
    function buildForm() {
      const fd = new FormData();
      fd.append('sessionToken', sessionToken);
      fd.append('email', email);
      fd.append('ticketId', String(ticketId));
      if (issueNumber) fd.append('issue_number', issueNumber);
      if (orderRef) fd.append('order_ref', orderRef);
      fd.append('file', file);
      return fd;
    }
    let res = await fetch(apiBase + '/damage-photo', { method: 'POST', body: buildForm() });
    if (res.status === 401 || res.status === 403) {
      sessionToken = null;
      try { sessionStorage.removeItem(TOKEN_KEY); } catch (e) {}
      if (await ensureSession()) {
        res = await fetch(apiBase + '/damage-photo', { method: 'POST', body: buildForm() });
      }
    }
    let data = null;
    try { data = await res.json(); } catch (e) {}
    return { status: res.status, data: data || {} };
  }

  function renderReshipmentForm(action) {
    var cibles = Array.isArray(action.cibles) ? action.cibles : [];
    var wrong = action.useCorrectedAddress === true;
    var options = '';
    cibles.forEach(function (c, i) { options += '<option value="' + i + '">' + esc(c.label) + '</option>'; });
    var checkLabel = wrong
      ? 'Je confirme que le numéro doit être renvoyé à ma BONNE adresse (celle que je viens d’enregistrer), pas à l’ancienne.'
      : 'Je confirme vouloir recevoir gratuitement le numéro à mon adresse enregistrée.';
    var card = el(
      '<div class="ea-assist-action">' +
        '<div class="ea-assist-action-title">Réexpédition gratuite du numéro</div>' +
        '<p class="ea-assist-action-detail">On te renvoie le numéro concerné, gratuitement (0 €).' + (wrong ? ' Il partira à ta bonne adresse corrigée.' : '') + '</p>' +
        '<form class="ea-assist-damage">' +
          '<label class="ea-assist-damage-label">Commande concernée' +
            '<select name="cible" class="ea-assist-damage-select">' + options + '</select>' +
          '</label>' +
          '<label class="ea-assist-reship-check"><input type="checkbox" name="confirm"> <span>' + esc(checkLabel) + '</span></label>' +
          '<div class="ea-assist-action-row">' +
            '<button type="submit" class="ea-assist-action-confirm" disabled>Confirmer la réexpédition</button>' +
            '<button type="button" class="ea-assist-action-dismiss">Annuler</button>' +
          '</div>' +
        '</form>' +
      '</div>'
    );
    var form = card.querySelector('form');
    var submitBtn = card.querySelector('.ea-assist-action-confirm');
    var select = card.querySelector('select[name="cible"]');
    var checkbox = card.querySelector('input[name="confirm"]');
    checkbox.addEventListener('change', function () { submitBtn.disabled = !checkbox.checked; });
    card.querySelector('.ea-assist-action-dismiss').addEventListener('click', function () { card.remove(); });
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (!checkbox.checked) return;
      var idx = parseInt(select.value, 10);
      var cible = (!isNaN(idx) && cibles[idx]) ? cibles[idx] : cibles[0];
      if (!cible || !cible.order_ref) {
        addInfo('<div class="ea-assist-fallback">Choisis la commande concernée.</div>');
        return;
      }
      submitBtn.disabled = true;
      submitBtn.textContent = 'Confirmation…';
      try {
        var r = await api('/confirm-reshipment', {
          sessionToken: sessionToken, email: email, conversationId: ensureConversationId(),
          orderRef: cible.order_ref, issueNumber: cible.issue_number || null, confirmed: true,
        });
        if (r.status === 200) {
          card.remove();
          addInfo('<div class="ea-assist-success">' + esc(r.data.message || 'C’est confirmé, on s’en occupe.') + '</div>');
          markActionDone('reshipment');
        } else {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Confirmer la réexpédition';
          addInfo('<div class="ea-assist-fallback">' + esc((r.data && r.data.error) || 'Impossible pour le moment, réessaie ou écris à abonnement@views.fr.') + '</div>');
        }
      } catch (err) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Confirmer la réexpédition';
        addInfo('<div class="ea-assist-fallback">Erreur réseau, réessaie.</div>');
      }
    });
    messagesBox.appendChild(card);
    messagesBox.scrollTop = messagesBox.scrollHeight;
  }

  function renderDamageForm(action) {
    const cibles = Array.isArray(action.cibles) ? action.cibles : [];
    let options = '<option value="">Je ne suis pas sûr(e)</option>';
    cibles.forEach(function (c, i) {
      options += '<option value="' + i + '">' + esc(c.label) + '</option>';
    });
    const card = el(
      '<div class="ea-assist-action">' +
        '<div class="ea-assist-action-title">Envoyer une photo du magazine abîmé</div>' +
        '<p class="ea-assist-action-detail">Choisis le numéro ou la commande concerné(e) et ajoute une photo (JPG, PNG, WebP ou HEIC, 8 Mo max). L’équipe la vérifie sous ' + SLA + '.</p>' +
        '<form class="ea-assist-damage">' +
          '<label class="ea-assist-damage-label">Numéro ou commande concerné(e)' +
            '<select name="cible" class="ea-assist-damage-select">' + options + '</select>' +
          '</label>' +
          '<label class="ea-assist-damage-label">Photo' +
            '<input type="file" name="photo" accept="image/jpeg,image/png,image/webp,image/heic,image/heif" class="ea-assist-damage-file">' +
          '</label>' +
          '<div class="ea-assist-action-row">' +
            '<button type="submit" class="ea-assist-action-confirm">Envoyer la photo</button>' +
            '<button type="button" class="ea-assist-action-dismiss">Annuler</button>' +
          '</div>' +
        '</form>' +
      '</div>'
    );
    const form = card.querySelector('form');
    const submitBtn = card.querySelector('.ea-assist-action-confirm');
    const fileInput = card.querySelector('input[name="photo"]');
    const select = card.querySelector('select[name="cible"]');
    card.querySelector('.ea-assist-action-dismiss').addEventListener('click', function () { card.remove(); });
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const file = fileInput.files && fileInput.files[0];
      if (!file) {
        addInfo('<div class="ea-assist-fallback">Ajoute une photo avant d’envoyer.</div>');
        return;
      }
      if (file.size > 8 * 1024 * 1024) {
        addInfo('<div class="ea-assist-fallback">Photo trop lourde (8 Mo maximum).</div>');
        return;
      }
      submitBtn.disabled = true;
      submitBtn.textContent = 'Envoi en cours…';
      const idx = parseInt(select.value, 10);
      const cible = (!isNaN(idx) && cibles[idx]) ? cibles[idx] : null;
      try {
        const r = await uploadDamagePhoto(
          action.ticketId,
          cible && cible.issue_number ? cible.issue_number : '',
          cible && cible.order_ref ? cible.order_ref : '',
          file,
        );
        if (r.status === 200 && r.data.success) {
          card.remove();
          addInfo('<div class="ea-assist-success">Photo bien reçue, l’équipe valide sous ' + SLA + '.</div>');
          markActionDone('damage_report');
        } else {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Envoyer la photo';
          addInfo('<div class="ea-assist-fallback">' + esc(r.data.error || 'Envoi impossible pour le moment, réessaie ou écris à abonnement@views.fr.') + '</div>');
        }
      } catch (err) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Envoyer la photo';
        addInfo(FALLBACK_HTML);
      }
    });
    messagesBox.appendChild(card);
    messagesBox.scrollTop = messagesBox.scrollHeight;
  }

  const TICKET_STATUS_FR = {
    open: 'reçue, en attente', in_progress: 'en cours de traitement',
    resolved: 'résolue', rejected: 'close sans suite',
  };
  const TICKET_MOTIF_FR = {
    delivery: 'Livraison', inquiry: 'Question', cancellation: 'Résiliation',
    complaint: 'Réclamation', billing: 'Facturation', account: 'Compte',
  };

  function blocsDemandes() {
    return panel.querySelectorAll('.ea-assist-tickets');
  }

  function marqueDemandes(ouvert) {
    const b = panel.querySelector('button.ea-assist-tickets-btn');
    if (b) b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
  }

  let chargementDemandes = false;

  async function showMyTickets() {
    if (chargementDemandes) return;
    const ouverts = blocsDemandes();
    if (ouverts.length) {
      ouverts.forEach(function (n) {
        const bulle = n.closest('.ea-assist-msg--info');
        (bulle || n).remove();
      });
      marqueDemandes(false);
      return;
    }
    chargementDemandes = true;
    if (!(await ensureSession())) {
      chargementDemandes = false;
      return;
    }
    try {
      const r = await api('/my-tickets', { sessionToken: sessionToken, email: email });
      if (r.status !== 200 || !Array.isArray(r.data.tickets)) {
        addInfo('<div class="ea-assist-fallback">Impossible de charger tes demandes pour le moment.</div>');
        return;
      }
      if (r.data.tickets.length === 0) {
        addInfo('<div class="ea-assist-tickets"><div class="ea-assist-tickets-head">Tes demandes</div><div class="ea-assist-tickets-empty">Aucune demande en cours. Si quelque chose ne va pas, dis-le moi ici : je crée le dossier pour toi.</div></div>');
        marqueDemandes(true);
        return;
      }
      const cards = r.data.tickets.map(function (t) {
        const motif = TICKET_MOTIF_FR[t.motif] || t.motif;
        const statut = TICKET_STATUS_FR[t.status] || t.status;
        const stClass = t.status === 'resolved' ? 'ok' : t.status === 'in_progress' ? 'doing' : t.status === 'rejected' ? 'closed' : 'waiting';
        const d = String(t.created_at || '').slice(0, 10);
        const dateFr = d ? d.slice(8, 10) + '/' + d.slice(5, 7) + '/' + d.slice(0, 4) : '';
        return '<div class="ea-assist-ticket">' +
          '<div class="ea-assist-ticket-top"><strong>SAV-' + esc(String(t.id)) + '</strong>' +
          '<span class="ea-assist-ticket-status ea-assist-ticket-status--' + stClass + '">' + esc(statut) + '</span></div>' +
          '<div class="ea-assist-ticket-sub">' + esc(motif) + (t.issue_number ? ' · Numéro ' + esc(t.issue_number) : '') +
          (dateFr ? ' · ouvert le ' + esc(dateFr) : '') + '</div>' +
          '</div>';
      }).join('');
      addInfo('<div class="ea-assist-tickets"><div class="ea-assist-tickets-head">Tes demandes (' + r.data.tickets.length + ')</div>' + cards + '</div>');
      marqueDemandes(true);
    } catch (e) {
      addInfo(FALLBACK_HTML);
    } finally {
      chargementDemandes = false;
    }
  }

  let feedbackShown = false;
  function offerFeedback() {
    if (feedbackShown || !conversationId) return;
    feedbackShown = true;
    const bar = el(
      '<div class="ea-assist-feedback">' +
        '<span>Cette réponse t’aide ?</span>' +
        '<button type="button" data-fb="up" aria-label="Oui, ça m’aide">👍</button>' +
        '<button type="button" data-fb="down" aria-label="Non, ça ne m’aide pas">👎</button>' +
      '</div>'
    );
    bar.addEventListener('click', function (e) {
      const btn = e.target.closest('button[data-fb]');
      if (!btn) return;
      api('/feedback', {
        sessionToken: sessionToken, email: email,
        conversationId: conversationId, feedback: btn.dataset.fb,
      });
      bar.innerHTML = '<span>Merci pour ton retour !</span>';
    });
    messagesBox.appendChild(bar);
    messagesBox.scrollTop = messagesBox.scrollHeight;
  }

  function injectEntryPoints() {
    const sidebar = container.querySelector('.ea-quick-actions');
    const hero = el(
      '<div class="ea-assist-hero">' +
        '<div class="ea-assist-hero-title">Une question sur ton abonnement ?</div>' +
        '<div class="ea-assist-hero-sub">Réponse immédiate, 24/7 : l’assistant connaît tes numéros, tes reçus et ton abonnement.</div>' +
        '<button type="button" class="ea-assist-hero-btn">Démarrer l’assistant</button>' +
      '</div>'
    );
    hero.querySelector('.ea-assist-hero-btn').addEventListener('click', openPanel);
    if (sidebar && sidebar.parentNode) {
      sidebar.parentNode.insertBefore(hero, sidebar);
    } else {
      container.insertBefore(hero, container.firstChild);
    }
    const mailAction = container.querySelector('a.ea-action[href^="mailto:abonnement"]');
    if (mailAction) {
      const swap = el('<button type="button" class="ea-action"><span class="ea-action-icon">' +
        '<svg viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>' +
        '</span>Poser ma question à l’assistant</button>');
      swap.addEventListener('click', openPanel);
      mailAction.replaceWith(swap);
    }
    detourneLesLiensMail(container);
  }

  function detourneLesLiensMail(racine) {
    const liens = (racine || document).querySelectorAll('a.ea-mail-fallback[href^="mailto:abonnement"]');
    for (const lien of liens) {
      if (lien.dataset.eaDetourne === '1') continue;
      lien.dataset.eaDetourne = '1';
      lien.addEventListener('click', function (ev) {
        if (!panel) return;
        ev.preventDefault();
        openPanel();
        const texte = lien.dataset.assist || '';
        if (texte && input && !input.value) {
          input.value = texte;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus({ preventScroll: true });
        }
      });
    }
  }

  const observateurLiens = new MutationObserver(function () { detourneLesLiensMail(document); });

  function whenSidebarReady(cb) {
    if (container.querySelector('.ea-quick-actions')) { cb(); return; }
    const obs = new MutationObserver(function () {
      if (container.querySelector('.ea-quick-actions')) {
        obs.disconnect();
        cb();
      }
    });
    obs.observe(container, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  }

  function injectLauncher() {
    const btn = el(
      '<button type="button" class="ea-assist-launcher" aria-label="Ouvrir l’assistant Views">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>' +
        '<span>Assistant</span>' +
      '</button>'
    );
    btn.addEventListener('click', openPanel);
    document.body.appendChild(btn);
  }

  fetch(apiBase + '/status').then(function (res) {
    if (!res.ok) return;
    if (launcherMode) {
      injectLauncher();
      let wasOpen = false;
      try { wasOpen = sessionStorage.getItem(OPEN_KEY) === '1'; } catch (e) {}
      if (location.hash === '#assistant' || wasOpen) openPanel();
      return;
    }
    whenSidebarReady(function () {
      injectEntryPoints();
      detourneLesLiensMail(document);
      observateurLiens.observe(document.body, { childList: true, subtree: true });
      let wasOpen = false;
      try { wasOpen = sessionStorage.getItem(OPEN_KEY) === '1'; } catch (e) {}
      if (location.hash === '#assistant' || wasOpen) openPanel();
    });
  }).catch(function () {});
})();
